import React from 'react';
import { Info } from 'components/Text';
import { NOT_AVAILABLE } from 'constants/text';
import useStyles from './ProfileStyles';
export default function ProfileItem({
  label,
  value
}) {
  const {
    profileItem,
    profileInfoItem,
    profileValue
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: profileItem
  }, /*#__PURE__*/React.createElement(Info, {
    className: profileInfoItem
  }, label), /*#__PURE__*/React.createElement("div", {
    className: profileValue
  }, value || NOT_AVAILABLE));
}